// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OiH6j","left":"styles_left__1drR2"};